{
  "golf": {
    "offers": [
      {
        "id": "golf-1",
        "image": "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=516&h=300&fit=crop&crop=center",
        "title": "Championship Golf Package",
        "description": "Save 20% on premium golf resorts with unlimited tee times and cart rentals.",
        "discount": "20% OFF",
        "originalPrice": "$450",
        "discountedPrice": "$360",
        "validUntil": "Dec 31, 2025",
        "buttonLink": "https://www.marriott.com/en-us/resorts/golf-resorts",
        "activities": [
          { "label": "Golf", "icon": "golf" },
          { "label": "Resort", "icon": "resort" },
          { "label": "Premium", "icon": "premium" },
          { "label": "4th Night FREE", "icon": "offer" }
        ]
      },
      {
        "id": "golf-2",
        "image": "https://images.unsplash.com/photo-1587174486073-ae5e5cff23aa?w=516&h=300&fit=crop&crop=center",
        "title": "Desert Golf Escape",
        "description": "Exclusive desert golf experience with spa treatments and gourmet dining.",
        "discount": "30% OFF",
        "originalPrice": "$650",
        "discountedPrice": "$455",
        "validUntil": "Jan 15, 2026",
        "buttonLink": "https://www.marriott.com/en-us/resorts/golf-resorts",
        "activities": [
          { "label": "Golf", "icon": "golf" },
          { "label": "Desert", "icon": "desert" },
          { "label": "Spa", "icon": "spa" },
          { "label": "4th Night FREE", "icon": "offer" }
        ]
      }
    ]
  },
  "beach": {
    "offers": [
      {
        "id": "beach-1",
        "image": "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=516&h=300&fit=crop&crop=center",
        "title": "Tropical Paradise Deal",
        "description": "Book 3 nights, get the 4th free at stunning beachfront resorts.",
        "discount": "25% OFF",
        "originalPrice": "$320",
        "discountedPrice": "$240",
        "validUntil": "Mar 31, 2026",
        "buttonLink": "https://traveler.marriott.com/mindful-travel/reconnect-travel-us-caribbean/",
        "activities": [
          { "label": "Beach", "icon": "sun" },
          { "label": "Tropical", "icon": "palm" },
          { "label": "Resort", "icon": "resort" },
          { "label": "4th Night FREE", "icon": "offer" }
        ]
      },
      {
        "id": "beach-2",
        "image": "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=516&h=300&fit=crop&crop=center",
        "title": "Coastal Adventure Package",
        "description": "Water sports, beachfront dining, and luxury accommodations included.",
        "discount": "40% OFF",
        "originalPrice": "$500",
        "discountedPrice": "$300",
        "validUntil": "Feb 28, 2026",
        "buttonLink": "https://activities.marriott.com/activities?term=beach",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Beach", "icon": "sun" },
          { "label": "Water Sports", "icon": "water" },
          { "label": "Adventure", "icon": "adventure" }
        ]
      }
    ]
  },
  "culinary": {
    "offers": [
      {
        "id": "culinary-1",
        "image": "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=516&h=300&fit=crop&crop=center",
        "title": "Michelin Star Experience",
        "description": "Exclusive chef's table experiences at world-renowned restaurants.",
        "discount": "15% OFF",
        "originalPrice": "$800",
        "discountedPrice": "$680",
        "validUntil": "Apr 30, 2026",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/culinary",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Fine Dining", "icon": "dining" },
          { "label": "Chef's Table", "icon": "chef" },
          { "label": "Michelin", "icon": "star" }
        ]
      },
      {
        "id": "culinary-2",
        "image": "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=516&h=300&fit=crop&crop=center",
        "title": "Culinary Tour Package",
        "description": "Multi-city food and wine tours with expert sommelier guidance.",
        "discount": "35% OFF",
        "originalPrice": "$1200",
        "discountedPrice": "$780",
        "validUntil": "Jun 15, 2026",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/culinary",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Culinary Tour", "icon": "tour" },
          { "label": "Wine Tasting", "icon": "wine" },
          { "label": "Sommelier", "icon": "expert" }
        ]
      }
    ]
  },
  "spa": {
    "offers": [
      {
        "id": "spa-1",
        "image": "https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=516&h=300&fit=crop&crop=center",
        "title": "Wellness Retreat Special",
        "description": "Complete spa package with daily treatments and wellness consultations.",
        "discount": "45% OFF",
        "originalPrice": "$900",
        "discountedPrice": "$495",
        "validUntil": "May 31, 2026",
        "buttonLink": "https://www.marriott.com/en-us/resorts/spa-resorts.mi",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Spa Treatments", "icon": "spa" },
          { "label": "Wellness", "icon": "wellness" },
          { "label": "Luxury Resort", "icon": "luxury" }
        ]
      },
      {
        "id": "spa-2",
        "image": "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=516&h=300&fit=crop&crop=center",
        "title": "Thermal Springs Escape",
        "description": "Natural hot spring therapy with holistic healing treatments.",
        "discount": "25% OFF",
        "originalPrice": "$600",
        "discountedPrice": "$450",
        "validUntil": "Jul 31, 2026",
        "buttonLink": "https://www.marriott.com/en-us/resorts/spa-resorts.mi",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Thermal Springs", "icon": "springs" },
          { "label": "Holistic Healing", "icon": "healing" },
          { "label": "Natural Therapy", "icon": "natural" }
        ]
      }
    ]
  },
  "ski": {
    "offers": [
      {
        "id": "ski-1",
        "image": "https://images.unsplash.com/photo-1551524164-6cf1ac14d1a4?w=516&h=300&fit=crop&crop=center",
        "title": "Alpine Ski Adventure",
        "description": "Lift tickets, equipment rental, and ski lessons included in luxury package.",
        "discount": "30% OFF",
        "originalPrice": "$750",
        "discountedPrice": "$525",
        "validUntil": "Mar 15, 2026",
        "buttonLink": "https://traveler.marriott.com/outdoor-activities/skiing-and-snowboarding/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Skiing", "icon": "ski" },
          { "label": "Alpine", "icon": "mountain" },
          { "label": "Luxury", "icon": "luxury" }
        ]
      },
      {
        "id": "ski-2",
        "image": "https://images.unsplash.com/photo-1605540436563-5bca919ae766?w=516&h=300&fit=crop&crop=center",
        "title": "Family Ski Package",
        "description": "Perfect for families with kids' ski school and childcare services.",
        "discount": "20% OFF",
        "originalPrice": "$600",
        "discountedPrice": "$480",
        "validUntil": "Feb 28, 2026",
        "buttonLink": "https://traveler.marriott.com/outdoor-activities/skiing-and-snowboarding/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Skiing", "icon": "ski" },
          { "label": "Family Friendly", "icon": "family" },
          { "label": "Kids Program", "icon": "kids" }
        ]
      }
    ]
  },
  "music": {
    "offers": [
      {
        "id": "music-1",
        "image": "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=516&h=300&fit=crop&crop=center",
        "title": "Music Festival VIP",
        "description": "Exclusive backstage access and VIP seating at premier music festivals.",
        "discount": "50% OFF",
        "originalPrice": "$1000",
        "discountedPrice": "$500",
        "validUntil": "Aug 31, 2026",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/entertainment",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Music Festivals", "icon": "festival" },
          { "label": "VIP Access", "icon": "vip" },
          { "label": "Backstage", "icon": "backstage" }
        ]
      },
      {
        "id": "music-2",
        "image": "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=516&h=300&fit=crop&crop=center",
        "title": "Concert Hall Experience",
        "description": "Premium seats at world-famous concert halls and opera houses.",
        "discount": "25% OFF",
        "originalPrice": "$400",
        "discountedPrice": "$300",
        "validUntil": "Sep 30, 2026",
        "buttonLink": "https://moments.marriottbonvoy.com/en-us/moments/category/entertainment",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Concerts", "icon": "music" },
          { "label": "Premium Seats", "icon": "premium" },
          { "label": "Opera", "icon": "opera" }
        ]
      }
    ]
  },
  "hike": {
    "offers": [
      {
        "id": "hike-1",
        "image": "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=516&h=300&fit=crop&crop=center",
        "title": "Mountain Trail Adventure",
        "description": "Guided hiking tours with luxury eco-lodge accommodations.",
        "discount": "35% OFF",
        "originalPrice": "$550",
        "discountedPrice": "$358",
        "validUntil": "Oct 31, 2026",
        "buttonLink": "https://www.marriott.com/en-us/national-parks",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Hiking", "icon": "hike" },
          { "label": "Mountain Trails", "icon": "mountain" },
          { "label": "Eco Lodge", "icon": "eco" }
        ]
      },
      {
        "id": "hike-2",
        "image": "https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?w=516&h=300&fit=crop&crop=center",
        "title": "Desert Hiking Expedition",
        "description": "Explore unique desert landscapes with expert geological guides.",
        "discount": "40% OFF",
        "originalPrice": "$400",
        "discountedPrice": "$240",
        "validUntil": "Nov 30, 2026",
        "buttonLink": "https://www.marriott.com/en-us/national-parks",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Desert Hiking", "icon": "desert" },
          { "label": "Geological Tours", "icon": "geology" },
          { "label": "Expert Guide", "icon": "expert" }
        ]
      }
    ]
  },
  "bike": {
    "offers": [
      {
        "id": "bike-1",
        "image": "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=516&h=300&fit=crop&crop=center",
        "title": "Scenic Cycling Package",
        "description": "Premium bike rentals and guided tours through picturesque routes.",
        "discount": "30% OFF",
        "originalPrice": "$350",
        "discountedPrice": "$245",
        "validUntil": "Sep 15, 2026",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/biking-cycling",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Cycling", "icon": "bike" },
          { "label": "Scenic Routes", "icon": "scenic" },
          { "label": "Guided Tours", "icon": "guide" }
        ]
      },
      {
        "id": "bike-2",
        "image": "https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=516&h=300&fit=crop&crop=center",
        "title": "Mountain Bike Adventure",
        "description": "Off-road mountain biking with professional equipment and instruction.",
        "discount": "25% OFF",
        "originalPrice": "$450",
        "discountedPrice": "$338",
        "validUntil": "Oct 15, 2026",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/biking-cycling",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Mountain Biking", "icon": "mountain-bike" },
          { "label": "Off-Road", "icon": "offroad" },
          { "label": "Professional", "icon": "professional" }
        ]
      }
    ]
  },
  "surf": {
    "offers": [
      {
        "id": "surf-1",
        "image": "https://images.unsplash.com/photo-1502680390469-be75c86b636f?w=516&h=300&fit=crop&crop=center",
        "title": "World-Class Surf Package",
        "description": "Access legendary surf breaks with board rentals and instruction.",
        "discount": "35% OFF",
        "originalPrice": "$480",
        "discountedPrice": "$312",
        "validUntil": "Aug 15, 2026",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-surf/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Surfing", "icon": "surf" },
          { "label": "Legendary Breaks", "icon": "waves" },
          { "label": "Instruction", "icon": "lesson" }
        ]
      },
      {
        "id": "surf-2",
        "image": "https://images.unsplash.com/photo-1530549387789-4c1017266635?w=516&h=300&fit=crop&crop=center",
        "title": "Surf School Paradise",
        "description": "Learn to surf in tropical paradise with certified instructors.",
        "discount": "40% OFF",
        "originalPrice": "$380",
        "discountedPrice": "$228",
        "validUntil": "Jul 31, 2026",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-surf/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Surf Lessons", "icon": "lesson" },
          { "label": "Tropical Paradise", "icon": "tropical" },
          { "label": "Certified Instructors", "icon": "certified" }
        ]
      }
    ]
  },
  "fishing": {
    "offers": [
      {
        "id": "fishing-1",
        "image": "https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?w=516&h=300&fit=crop&crop=center",
        "title": "Deep Sea Fishing Charter",
        "description": "Full-day deep sea fishing with professional crew and equipment.",
        "discount": "30% OFF",
        "originalPrice": "$600",
        "discountedPrice": "$420",
        "validUntil": "Jun 30, 2026",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-fish/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Deep Sea Fishing", "icon": "fishing" },
          { "label": "Professional Crew", "icon": "professional" },
          { "label": "Full Day", "icon": "fullday" }
        ]
      },
      {
        "id": "fishing-2",
        "image": "https://images.unsplash.com/photo-1519904981063-b0cf448d479e?w=516&h=300&fit=crop&crop=center",
        "title": "Fly Fishing Retreat",
        "description": "Master fly fishing in pristine mountain streams with expert guides.",
        "discount": "25% OFF",
        "originalPrice": "$520",
        "discountedPrice": "$390",
        "validUntil": "Sep 30, 2026",
        "buttonLink": "https://traveler.marriott.com/watersports/best-places-to-fish/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Fly Fishing", "icon": "flyfish" },
          { "label": "Mountain Streams", "icon": "stream" },
          { "label": "Expert Guide", "icon": "expert" }
        ]
      }
    ]
  },
  "paddle": {
    "offers": [
      {
        "id": "paddle-1",
        "image": "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=516&h=300&fit=crop&crop=center",
        "title": "Kayaking Adventure Package",
        "description": "Multi-day kayaking tours through pristine waterways and hidden coves.",
        "discount": "35% OFF",
        "originalPrice": "$450",
        "discountedPrice": "$293",
        "validUntil": "Aug 31, 2026",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/kayaking-and-canoeing",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Kayaking", "icon": "kayak" },
          { "label": "Multi-Day Tours", "icon": "tour" },
          { "label": "Hidden Coves", "icon": "cove" }
        ]
      },
      {
        "id": "paddle-2",
        "image": "https://images.unsplash.com/photo-1544551763-77ef2d0cfc6c?w=516&h=300&fit=crop&crop=center",
        "title": "Stand-Up Paddle Boarding",
        "description": "SUP lessons and equipment in beautiful coastal locations worldwide.",
        "discount": "20% OFF",
        "originalPrice": "$280",
        "discountedPrice": "$224",
        "validUntil": "Oct 31, 2026",
        "buttonLink": "https://www.marriott.com/en-us/outdoors/kayaking-and-canoeing",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Stand-Up Paddle", "icon": "sup" },
          { "label": "Coastal Locations", "icon": "coastal" },
          { "label": "Equipment Included", "icon": "equipment" }
        ]
      }
    ]
  },
  "safari": {
    "offers": [
      {
        "id": "safari-1",
        "image": "https://images.unsplash.com/photo-1549366021-9f761d040a94?w=516&h=300&fit=crop&crop=center",
        "title": "Great Migration Safari",
        "description": "Witness the world's greatest wildlife migration in luxury tented camps.",
        "discount": "40% OFF",
        "originalPrice": "$2500",
        "discountedPrice": "$1500",
        "validUntil": "Dec 31, 2025",
        "buttonLink": "https://traveler.marriott.com/safari/hotel-outdoor-experiences/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Great Migration", "icon": "migration" },
          { "label": "Wildlife Safari", "icon": "safari" },
          { "label": "Luxury Camping", "icon": "luxury-camp" }
        ]
      },
      {
        "id": "safari-2",
        "image": "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=516&h=300&fit=crop&crop=center",
        "title": "Luxury Tented Safari",
        "description": "Premium safari experience with world-class accommodations and guides.",
        "discount": "30% OFF",
        "originalPrice": "$1800",
        "discountedPrice": "$1260",
        "validUntil": "Mar 31, 2026",
        "buttonLink": "https://traveler.marriott.com/safari/hotel-outdoor-experiences/",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Luxury Safari", "icon": "luxury-safari" },
          { "label": "Tented Camps", "icon": "tent" },
          { "label": "Expert Guides", "icon": "guide" }
        ]
      }
    ]
  },
  "am-drinks": {
    "offers": [
      {
        "id": "am-drinks-1",
        "image": "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=516&h=300&fit=crop&crop=center",
        "title": "Artisan Coffee Experience",
        "description": "Premium coffee tasting sessions with world-renowned baristas.",
        "discount": "25% OFF",
        "originalPrice": "$120",
        "discountedPrice": "$90",
        "validUntil": "Dec 31, 2025",
        "buttonLink": "https://www.marriott.com/en-us/hotels/hotel-search.mi",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Artisan Coffee", "icon": "coffee" },
          { "label": "Tasting Sessions", "icon": "tasting" },
          { "label": "Expert Baristas", "icon": "barista" }
        ]
      },
      {
        "id": "am-drinks-2",
        "image": "https://images.unsplash.com/photo-1506619216599-9d16d0903dfd?w=516&h=300&fit=crop&crop=center",
        "title": "Fresh Juice & Smoothie Bar",
        "description": "All-inclusive access to premium juice and smoothie bars.",
        "discount": "30% OFF",
        "originalPrice": "$80",
        "discountedPrice": "$56",
        "validUntil": "Feb 28, 2026",
        "buttonLink": "https://www.marriott.com/en-us/hotels/hotel-search.mi",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Fresh Juices", "icon": "juice" },
          { "label": "Smoothie Bar", "icon": "smoothie" },
          { "label": "All-Inclusive", "icon": "inclusive" }
        ]
      }
    ]
  },
  "evening-drinks": {
    "offers": [
      {
        "id": "evening-drinks-1",
        "image": "https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=516&h=300&fit=crop&crop=center",
        "title": "Craft Cocktail Experience",
        "description": "Exclusive mixology classes with celebrity bartenders and premium spirits.",
        "discount": "35% OFF",
        "originalPrice": "$200",
        "discountedPrice": "$130",
        "validUntil": "Apr 30, 2026",
        "buttonLink": "https://traveler.marriott.com/eat-and-drink/bars/",
        "activities": [
          { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Craft Cocktails", "icon": "cocktail" },
          { "label": "Mixology Classes", "icon": "mixology" },
          { "label": "Celebrity Bartenders", "icon": "celebrity" }
        ]
      },
      {
        "id": "evening-drinks-2",
        "image": "https://images.unsplash.com/photo-1510972527921-ce03766a1cf1?w=516&h=300&fit=crop&crop=center",
        "title": "Wine Tasting Journey",
        "description": "Curated wine experiences at prestigious vineyards worldwide.",
        "discount": "40% OFF",
        "originalPrice": "$300",
        "discountedPrice": "$180",
        "validUntil": "Jun 15, 2026",
        "buttonLink": "https://www.marriott.com/en-us/hotels/hotel-search.mi",
        "activities": [
            { "label": "4th Night FREE", "icon": "offer" },
          { "label": "Wine Tasting", "icon": "wine" },
          { "label": "Prestigious Vineyards", "icon": "vineyard" },
          { "label": "Curated Experience", "icon": "curated" }
        ]
      }
    ]
  }
}